import { render, staticRenderFns } from "./rm-switcher.vue?vue&type=template&id=03ef3b34&"
import script from "./rm-switcher.vue?vue&type=script&lang=js&"
export * from "./rm-switcher.vue?vue&type=script&lang=js&"
import style0 from "./rm-switcher.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports